import React, { useState } from 'react';
import { Pagination } from 'react-bootstrap';

const IHN0101_ImgPagination = ( props ) => {
  const totalPages = Math.ceil(props.totalItems / props.sizePerPage);
  const handlePageChange = (pageNumber) => {
    props.onPageChange(pageNumber);
  };
  var pageNo = JSON.parse(JSON.stringify(props.pageNo));
  if (pageNo > totalPages){
    handlePageChange(1);
  }

  const pageRangeDisplayed = 4;
  let startPage = 1; 
  let endPage = totalPages;

  if (totalPages <= pageRangeDisplayed) {
      startPage = 1;
      endPage = totalPages;
  } else if (pageNo <= Math.ceil(pageRangeDisplayed / 2)) {
      startPage = 1;
      endPage = pageRangeDisplayed;
  } else if (pageNo + Math.floor(pageRangeDisplayed / 2) >= totalPages) {
      startPage = totalPages - pageRangeDisplayed + 1;
      endPage = totalPages;
  } else {
      // Current page is somewhere in the middle
      startPage = pageNo - Math.floor(pageRangeDisplayed / 2);
      endPage = pageNo + (Math.floor(pageRangeDisplayed / 2) - 1);
  }

  if (startPage < 1){
    startPage = 1;
  } 
  if (endPage > totalPages){
    endPage = totalPages;
  } 
  const pageArrayLength = endPage - startPage + 1;
  const pages = pageArrayLength > 0 ? [...Array(pageArrayLength).keys()] : [];
  String.prototype.format = function () {
    var content = this;
    for (var i = 0; i < arguments.length; i++) {
        var replacement = '{' + i + '}';
        content = content.replace(replacement, arguments[i]);
    }
    return content;
};

const sizePerPageList = [
    { text: '10件', value: 10 },
    { text: '25件', value: 25 },
    { text: '50件', value: 50 },
    { text: '100件', value: 100 },
];
var selectedSize = sizePerPageList.filter(option => option.value == props.sizePerPage)[0];
if (selectedSize === null || selectedSize === undefined) {
    selectedSize = sizePerPageList[3];
}
var sizePerPage = selectedSize.value;

function renderShowTotal(start, to, total) {
    let totalText = props.getTranslateValue(props.translate.current, "views.shared.showtotal");
    let tokens = totalText.split('[');
    let firstHalf = tokens[0].format(total);
    firstHalf = `${start}-${to}${firstHalf}`
    let secondHalf = tokens[1].split(']')[1].format(total, null, null);
    let displayPagination = props.length === 0 ? "d-none" : "d-block";
    return (
        <div className={displayPagination} style={{ marginBottom: "4px" }}>
            <span>{firstHalf}</span>
            <RenderSizeDropdown />
            <span>{secondHalf}</span>
        </div>
    )
}

function RenderSizeDropdown() {
    return (
        <span className="dropdown react-bs-table-sizePerPage-dropdown">
            <select value={selectedSize.value} className="multiselect dropdown-toggle input-group-text" style={{ display: "inline-grid" }} onChange={e => props.setSizePerPage(e.target.value)}>
                {
                    sizePerPageList.map(function (option, index) {
                        return <option key={index} value={option.value}>{option.text}</option>
                    })
                }
            </select>
        </span>
    )
}

return (
  <div className={props.disabled ? "d-none" : ""}> 
    <div className="col-sm-12 col-md-6 col-lg-6" style={{ textAlign: 'left' }}>
      {renderShowTotal(
              ((pageNo - 1) * sizePerPage) + 1,
              (pageNo * sizePerPage >= props.length ? props.length : pageNo * sizePerPage), 
              props.length)}
    </div>
    <div className="col-sm-12 col-md-6 col-lg-6" style={{ textAlign: 'right'}}>
      <Pagination className="react-bootstrap-table-page-btns-ul pagination" style={{ marginTop:'0px', marginBottom:'0px' }}>
        <Pagination.First
          className="page-item"
          hidden={pageNo < 3}
          disabled={pageNo < 3}
          onClick={() => handlePageChange(1)}
        />
        <Pagination.Prev
          className="page-item"
          hidden={pageNo === 1}
          disabled={pageNo === 1}
          onClick={() => handlePageChange(pageNo - 1)}
        />
        {pages.map((_, index) => (
          <Pagination.Item
            className="page-item"
            key={startPage + index}
            active={startPage + index === pageNo}
            onClick={() => handlePageChange(startPage + index)}
          >
            {startPage + index}
          </Pagination.Item>
        ))}
        <Pagination.Next
          className="page-item"
          hidden={pageNo === totalPages}
          disabled={pageNo === totalPages}
          onClick={() => handlePageChange(pageNo + 1)}
        />
        <Pagination.Last
          className="page-item"
          hidden={pageNo > (totalPages - 3)}
          disabled={pageNo > (totalPages - 3)}
          onClick={() => handlePageChange(totalPages)}
        />
      </Pagination>
    </div>
  </div>
  );
};

export default IHN0101_ImgPagination;


// WEBPACK FOOTER //
// ./view/IHN0101/IHN0101-imgpagination.jsx